// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OzThgRXthNa80zvPyx_Z7 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n", ""]);
// Exports
exports.locals = {
	"profileAvatar": "OzThgRXthNa80zvPyx_Z7"
};
module.exports = exports;
